import { getApiBaseUrl } from '../config/apiBase';

function filtersUrl(projectName, extra = {}) {
  const params = new URLSearchParams({
    project: String(projectName || 'default'),
    ...extra,
  });
  return `${getApiBaseUrl()}/saved_hole_filters.php?${params.toString()}`;
}

export async function fetchHoleFilters(projectName) {
  try {
    const res = await fetch(filtersUrl(projectName), { credentials: 'include' });
    const data = await res.json().catch(() => ({}));
    if (!res.ok || !data?.success || !Array.isArray(data.filters)) {
      return { ok: false, filters: [] };
    }
    return { ok: true, filters: data.filters };
  } catch {
    return { ok: false, filters: [] };
  }
}

export async function postHoleFilter(projectName, filter) {
  const res = await fetch(filtersUrl(projectName), {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(filter),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok || !data?.success) {
    throw new Error(data?.error || 'Could not save filter');
  }
  return data.filter || filter;
}

export async function deleteHoleFilterRemote(projectName, id) {
  const res = await fetch(filtersUrl(projectName, { id: String(id) }), {
    method: 'DELETE',
    credentials: 'include',
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok || !data?.success) {
    throw new Error(data?.error || 'Could not delete filter');
  }
}
